import React from "react";
import { Navigate } from "react-router-dom";
import { useAccess } from "../../../context-controller-mod/context-serv/permission-provider/useAccess";
import { useFallbackRoute } from "./useFallbackRoute.type";

interface PermissionRouteProps {
  element: React.ReactElement;
  resource: string;
  permission: string;
  action: string | string[];
}

export const PermissionRoute: React.FC<PermissionRouteProps> = ({
  element,
  resource,
  permission,
  action
}) => {
  const { fallback, loading } = useFallbackRoute();

  const allowed = useAccess(
    resource,
    permission,
    Array.isArray(action) ? action : [action]
  );

  if (loading || !fallback) return null;

  if (!allowed) {
    return <Navigate to={fallback} replace />;
  }

  return element;
};